import { render, staticRenderFns } from "./relationModal.vue?vue&type=template&id=94a03170&scoped=true&"
import script from "./relationModal.vue?vue&type=script&lang=js&"
export * from "./relationModal.vue?vue&type=script&lang=js&"
import style0 from "./relationModal.vue?vue&type=style&index=0&id=94a03170&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a03170",
  null
  
)

export default component.exports